import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FooterDataService {
  environment = environment;

  constructor(
    private http: HttpClient,
    private auth: AuthService,
  ) {
  }

  cancelSubscription() {
    return this.http.post(`${this.environment.apiUrl}/subscription/cancel`, null, {
      headers: {
        Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
      }
    });
  }

  subscribe() {
    return this.http.post(`${this.environment.apiUrl}/subscribe`, null, {
      headers: {
        Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
      }
    });
  }
  unsubscribe() {
    return this.http.post(`${this.environment.apiUrl}/unsubscribe`, null, {
      headers: {
        Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
      }
    });
  }
}
